// @flow

import * as React from 'react';
import { graphql, useFragment } from 'react-relay';
import { Flex } from 'react-system';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { useLocale } from '../../../controls/locale';
import { type Descriptor, createDescriptor } from '../../../controls/router';
import * as icons from '../../../icons';
import {
  type PageParams,
  pageDescriptor,
  type LocationParams,
  locationDescriptor,
} from '../sharedDescriptors';
import type { LocationFilter_root$key } from './__generated__/LocationFilter_root.graphql.js';

export const topFilterDescriptor: Descriptor<{|
  ...PageParams,
  ...LocationParams,
|}> = createDescriptor(pageDescriptor, locationDescriptor);

type Props = {|
  root: LocationFilter_root$key,
  title: string,
  onChange?: () => void,
  hero?: boolean,
|};

export const LocationFilter = (props: Props): React.Node => {
  const { t } = useLocale();
  const [location, setLocation, flushLocation] = topFilterDescriptor.useState();
  const { hero } = props;

  const root = useFragment(
    graphql`
      fragment LocationFilter_root on Query {
        developmentProductInfo {
          states {
            state
            developmentsCount
          }
        }
      }
    `,
    props.root,
  );

  return (
    <FormControl variant="outlined">
      <Select
        value={location.location ?? ''}
        onChange={e => {
          setLocation({
            location: e.target.value,
            page: 0,
          });
          flushLocation();
          props.onChange && props.onChange();
        }}
        renderValue={value => {
          return (
            <Flex alignItems={'center'}>
              {hero !== true && (
                <icons.LocationPin css={{ marginRight: '10px' }} />
              )}{' '}
              {value === 'all' ? t('any') : value || props.title}
            </Flex>
          );
        }}
        fullWidth={true}
        displayEmpty={true}
      >
        <MenuItem value="" disabled={true}>
          {props.title}
        </MenuItem>
        <MenuItem key={'all'} value={'all'}>
          {t('all')}
        </MenuItem>
        {root.developmentProductInfo.states.map(item => (
          <MenuItem key={item?.state} value={item?.state}>
            {item?.state} ({item?.developmentsCount})
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
